// REACT IMPORTS
import React from "react";

// PROPS TYPES
interface TabSwitchProps {
  rightText: string;
  leftText: string;
  selected?: boolean;
  selectedText?: string;
  onClick: (e: boolean) => void;
  disabled?: boolean;
  disabledTab?: string[];
}
/* ------------------------------------- TAB SWITCH ------------------------------------- */

const TabSwitch = (props: TabSwitchProps) => {
  const {
    rightText,
    leftText,
    selected = true,
    onClick,
    disabled,
    selectedText,
    disabledTab = [""],
  } = props;

  return (
    <div
      className={`grid grid-cols-2 md2:w-fit w-full rounded-sm items-center  select-none `}
    >
      <div
        className={`h-full py-[9px] text-sm leading-[18.23px] flex rounded-s-[2px] items-center border justify-center ${
          disabled || disabledTab.includes("left")
            ? selected
              ? "!bg-btnPrimaryInactive text-white border-btnPrimaryInactive px-3 cursor-not-allowed "
              : "!bg-bgThird !text-btnPrimaryInactive border-btnPrimaryInactive px-4 cursor-not-allowed"
            : selected
            ? "bg-blue text-white font-bold border-blue px-3 cursor-pointer hover:!bg-btnPrimaryHover hover:!border-btnPrimaryHover"
            : "text-blue font-normal bg-bgPrimary border-blue px-4 cursor-pointer hover:!bg-bgHover"
        } `}
        onClick={() => {
          if (
            !disabled &&
            !disabledTab.includes("left") &&
            selectedText !== "left"
          ) {
            onClick(true);
          }
        }}
      >
        {leftText}
      </div>

      <div
        className={`h-full py-[9px] text-sm leading-[18.23px] rounded-e-[2px] flex items-center border justify-center ${
          disabled || disabledTab.includes("right")
            ? !selected
              ? "!bg-btnPrimaryInactive text-white border-btnPrimaryInactive px-3 cursor-not-allowed"
              : "!bg-bgThird !text-btnPrimaryInactive border-btnPrimaryInactive px-4 cursor-not-allowed"
            : !selected
            ? "bg-blue text-white font-bold border-blue px-3 cursor-pointer hover:!bg-btnPrimaryHover hover:!border-btnPrimaryHover"
            : "text-blue font-normal bg-bgPrimary border-blue px-4 cursor-pointer  hover:!bg-bgHover"
        } `}
        onClick={() => {
          if (
            !disabled &&
            !disabledTab.includes("right") &&
            selectedText !== "right"
          ) {
            onClick(false);
          }
        }}
      >
        {rightText}
      </div>
    </div>
  );
};

export default TabSwitch;
